<div class="timeline">
  <div class="wrapper">
    <div class="common-card">
      <div class="start">Campaign Started</div>
      <span class="material-icons">navigate_next</span>
    </div>
    <div class="common-card">
      <div class="donate">{{states[params?.is_donor]?.label}} <span *ngIf="params?.is_donor==1 && params?.donated_currency && params?.donated_amount"><app-currency-icon [currency]="params?.donated_currency"></app-currency-icon>{{params?.donated_amount}}</span></div>
      <span class="material-icons">navigate_next</span>
    </div>
    <div class="common-card">
      <div class="update">Latest Update</div>
      <span class="material-icons">navigate_next</span>
    </div>
    <div class="common-card">
      <div class="help-more">
        <div class="btn" (click)="helpMore()">Help More</div>
      </div>
    </div>
  </div>
</div>